import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config/config.service';
import { ICustomerAppsConfig } from '../../config/config.module';

export interface ClientAuthenticationTokensForMember {
  memberId: number;
  minimalToken: string;
  regularToken?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ClientAuthenticationService {
  constructor(private httpClient: HttpClient, private configService: ConfigService<ICustomerAppsConfig>) {}

  getTokens(): Observable<ClientAuthenticationTokensForMember[]> {
    return this.httpClient.get<ClientAuthenticationTokensForMember[]>(`${this.configService.config.apiUrl}/client-authentication/tokens`);
  }
}
